import Strings from '../../../translations/strings';
import { getBaseUrl } from '../../../api/legacyApi';
import outlookImg from '../../../img/icons-eway/outlook-01.svg'
import webImg from '../../../img/icons-eway/web-01.svg'
import mobileImg from '../../../img/icons-eway/phone-01.svg'
import appleLogoIcon from '../../../img/icons-vendors/icons-apple-logo.svg'
import androidLogoIcon from '../../../img/icons-vendors/icons-android-os.svg'
import adminImg from '../../../img/icons-eway/admin-01.svg'
import office365AppImg from '../../../img/icons-eway/office365app.svg'
import supportImg from '../../../img/icons-eway/support-01.svg'

export interface ICard {
    id: number;
    title: () => string;
    img: string;
    link: (props: ICardLink) => string;
    btnText: () => string;
    btnOptions?: IbtnOptions[];
}

interface ICardLink {
    eWayVersion?: string;
}

export interface IbtnOptions {
    text: string;
    iconType: string;
    icon: string;
    link: () => string;
}

const currentUrl = getBaseUrl();

export const cards: ICard[] = [
    {
        id: 1,
        title: () => Strings.components.cards.titleOutlook,
        link: ({ eWayVersion }) =>
            eWayVersion ? `https://download.eway-crm.com/setup/eWayCRM-${eWayVersion}.exe` : '',
        img: outlookImg,
        btnText: () => Strings.components.cards.btnOutlook,
    },
    {
        id: 2,
        title: () => Strings.components.cards.titleWeb,
        link: () => `${currentUrl}/Web`,
        img: webImg,
        btnText: () => Strings.components.cards.btnWeb,
    },
    {
        id: 3,
        title: () => Strings.components.cards.titleMobile,
        link: () => '',
        img: mobileImg,
        btnText: () => Strings.components.cards.btnMobile,
        btnOptions: [
            {
                text: 'iOS',
                iconType: 'svg',
                icon: appleLogoIcon,
                link: () => 'https://apps.apple.com/us/app/eway-crm/id1129888734',
            },
            {
                text: 'Android',
                iconType: 'svg',
                icon: androidLogoIcon,
                link: () => 'https://play.google.com/store/apps/details?id=com.eway_crm.mobile.androidapp',
            },
        ],
    },
    {
        id: 4,
        title: () => Strings.components.cards.titleOffice365App,
        link: () => Strings.components.cards.linkOffice365App,
        img: office365AppImg,
        btnText: () => Strings.components.cards.btnOffice365App,
    },
    {
        id: 5,
        title: () => Strings.components.cards.titleAdminCenter,
        link: () => `${currentUrl}/admin`,
        img: adminImg,
        btnText: () => Strings.components.cards.btnAdmin,
    },
    {
        id: 6,
        title: () => Strings.components.cards.titleContactSupport,
        link: ({ eWayVersion }) => `${Strings.components.cards.linkSupport}`,
        img: supportImg,
        btnText: () => Strings.components.cards.btnHelpdesk,
    },
];
